<div style="width: 100%;">
  <div style="width: 100%; text-align: -webkit-right; margin: 10px;">
    <button class="primary buttonStylePrimary" (click)="addCustomer()">
      Agregar Cliente
    </button>
  </div>

  <div class="row" style="width: 100%;">
    <div class="col-2"><p class="pTableTitle">Imagen</p></div>
    <div class="col-2"><p class="pTableTitle">Nombre</p></div>
    <div class="col-2"><p class="pTableTitle">Teléfono</p></div>
    <div class="col-2"><p class="pTableTitle">Chat Mesa Ayuda</p></div>
    <div class="col-2"><p class="pTableTitle">URL página</p></div>
    <div class="col-2"><p class="pTableTitle">Acción</p></div>
  </div>

  <hr>

  <ng-container *ngFor="let customer of customers">
    <div class="row" style="width: 100%;">
      <div class="col-2">
        <ng-container *ngIf="customer.cus_url_image_web">
          <img [src]="customer.cus_url_image_web" width="100%">
        </ng-container>
        <ng-container *ngIf="!customer.cus_url_image_web">
          <p class="pTableNotInfo">No tiene imagen</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="customer.cus_name">
          <p class="pTableInfo">{{ customer.cus_name }}</p>
        </ng-container>
        <ng-container *ngIf="!customer.cus_name">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="customer.cus_url_phone">
          <p class="pTableInfo">{{ customer.cus_url_phone }}</p>
        </ng-container>
        <ng-container *ngIf="!customer.cus_url_phone">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="customer.cus_url_wsp">
          <p class="pTableInfo">{{ customer.cus_url_wsp }}</p>
        </ng-container>
        <ng-container *ngIf="!customer.cus_url_wsp">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="customer.cus_url_site">
          <p class="pTableInfo">{{ customer.cus_url_site }}</p>
        </ng-container>
        <ng-container *ngIf="!customer.cus_url_site">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-2" style="text-align: center;">
        <button
          type="button"
          class="btn btn-secondary actionButton"
          (click)="deleteCustomer(customer)">
          <mat-icon>delete_outline</mat-icon>
        </button>

        <button
          type="button"
          class="btn btn-secondary actionButton"
          (click)="editCustomer(customer)">
          <mat-icon>edit</mat-icon>
        </button>

        <button
          type="button"
          class="btn btn-secondary actionButton"
          (click)="showProducts(customer)">
          <mat-icon>list</mat-icon>
        </button>
      </div>
    </div>

    <hr>
  </ng-container>
</div>

<!-- ========================================================= -->
<!-- MODAL EDITAR CLIENTE -->
<!-- ========================================================= -->
<div
  class="modal fade"
  id="editCustomer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="editCustomer"
  aria-hidden="true">

  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content customer-modal-content">

      <div class="modal-header customer-modal-header justify-content-between align-items-center">
        <div>
          <h4 class="m-0 customer-modal-title">Editar cliente</h4>
          <small class="customer-modal-subtitle">
            Actualiza datos y configuraciones del cliente.
          </small>
        </div>

        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseEditCustomerModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body p-0">

        <!-- TABS -->
        <div class="customer-tabs-box">
          <ul class="nav nav-tabs border-0" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-datos-tab"
                data-toggle="tab"
                href="#tab-datos"
                role="tab"
                aria-controls="tab-datos"
                aria-selected="true">
                Datos y configuración
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-colores-tab"
                data-toggle="tab"
                href="#tab-colores"
                role="tab"
                aria-controls="tab-colores"
                aria-selected="false">
                Colores
              </a>
            </li>

            <li class="nav-item" *ngIf="editCustomerSelected.cus_id == 4">
              <a
                class="nav-link"
                id="tab-colores-default-tab"
                data-toggle="tab"
                href="#tab-colores-default"
                role="tab"
                aria-controls="tab-colores-default"
                aria-selected="false">
                Colores predeterminados
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-fondos-tab"
                data-toggle="tab"
                href="#tab-fondos"
                role="tab"
                aria-controls="tab-fondos"
                aria-selected="false">
                Fondos por perfil
              </a>
            </li>

            <li class="nav-item" *ngIf="editCustomerSelected.cus_id == 4">
              <a
                class="nav-link"
                id="tab-fondos-default-tab"
                data-toggle="tab"
                href="#tab-fondos-default"
                role="tab"
                aria-controls="tab-fondos-default"
                aria-selected="false">
                Fondos predeterminados
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-content customer-tab-content">

          <!-- ========================================================= -->
          <!-- TAB DATOS Y CONFIGURACIÓN -->
          <!-- ========================================================= -->
          <div
            class="tab-pane fade"
            id="tab-datos"
            role="tabpanel"
            aria-labelledby="tab-datos-tab">

            <form [formGroup]="editCustomerForm" novalidate>

              <div class="customer-section mb-3">
                <div class="customer-section-title mb-3">
                  Datos del cliente
                </div>

                <div class="row">
                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      Nombre <span class="customer-required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control customer-control"
                      formControlName="cus_name"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'cus_name', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'cus_name', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'cus_name') }}
                    </div>
                  </div>

                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      URL página <span class="customer-required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control customer-control"
                      formControlName="cus_url"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'cus_url', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'cus_url', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'cus_url') }}
                    </div>
                  </div>

                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      Teléfono <span class="customer-required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control customer-control"
                      formControlName="cus_phone"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'cus_phone', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'cus_phone', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'cus_phone') }}
                    </div>
                  </div>

                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      Chat Ayuda 24/7 <span class="customer-required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control customer-control"
                      formControlName="cus_url_wsp"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'cus_url_wsp', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'cus_url_wsp', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'cus_url_wsp') }}
                    </div>
                  </div>

                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      Link Centro de Ayuda <span class="customer-required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control customer-control"
                      formControlName="link_centro_ayuda"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'link_centro_ayuda', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'link_centro_ayuda', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'link_centro_ayuda') }}
                    </div>
                  </div>

                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      Link ir al Sitio Web <span class="customer-required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control customer-control"
                      formControlName="link_volver_sitio"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'link_volver_sitio', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'link_volver_sitio', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'link_volver_sitio') }}
                    </div>
                  </div>

                  <div class="col-12 col-md-3 mb-3">
                    <label class="customer-label">
                      Mail de Contacto <span class="customer-required">*</span>
                    </label>
                    <input
                      type="email"
                      class="form-control customer-control"
                      formControlName="cus_mail_contact"
                      [class.is-invalid]="isFieldInvalid(editCustomerForm, 'cus_mail_contact', editCustomerSubmitted)">
                    <div
                      class="customer-error"
                      *ngIf="isFieldInvalid(editCustomerForm, 'cus_mail_contact', editCustomerSubmitted)">
                      {{ getFieldError(editCustomerForm, 'cus_mail_contact') }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- CONFIGURACIONES -->
              <div class="customer-section mb-3">
                <div class="customer-section-title mb-3">
                  Configuraciones
                </div>

                <div class="row customer-config-list">

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Medios de pago</div>

                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-pay"
                          formControlName="cus_can_pay">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-pay">
                          WebPay
                        </label>
                      </div>

                      <div class="custom-control custom-checkbox mt-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-snabb"
                          formControlName="cus_can_snabb">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-snabb">
                          Snabb
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Convenios particulares</div>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-convenios"
                          formControlName="cus_can_convenio_particular">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-convenios">
                          Tiene convenios particulares
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Medios de pago Suscripción a planes</div>

                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-subscription-planilla"
                          formControlName="cus_can_subscription_planilla">
                        <label
                          class="custom-control-label customer-checkbox-label"
                          for="edit-checkbox-can-subscription-planilla">
                          Descuento por planilla
                        </label>
                      </div>

                      <div class="custom-control custom-checkbox mt-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-subscription-card"
                          formControlName="cus_can_subscription_card">
                        <label
                          class="custom-control-label customer-checkbox-label"
                          for="edit-checkbox-can-subscription-card">
                          Tarjeta
                        </label>
                      </div>

                      <div
                        *ngIf="editCustomerForm.get('cus_can_subscription_card')?.value"
                        class="mt-2 pl-4">

                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="edit-checkbox-can-subscription-mp"
                            formControlName="cus_can_subscription_mp">
                          <label
                            class="custom-control-label customer-checkbox-label"
                            for="edit-checkbox-can-subscription-mp">
                            Mercado Pago
                          </label>
                        </div>

                        <div class="custom-control custom-checkbox mt-1">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="edit-checkbox-can-subscription-wp"
                            formControlName="cus_can_subscription_wp">
                          <label
                            class="custom-control-label customer-checkbox-label"
                            for="edit-checkbox-can-subscription-wp">
                            WebPay - OneClick
                          </label>
                        </div>
                        <div class="custom-control custom-checkbox mt-1">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="edit-checkbox-can-subscription-vp"
                            formControlName="cus_can_subscription_vp">
                          <label
                            class="custom-control-label customer-checkbox-label"
                            for="edit-checkbox-can-subscription-vp">
                            Virtual POS
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Beneficios</div>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-show"
                          formControlName="cus_can_show_agreement">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-show">
                          Se visualizan beneficios y prestaciones
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">IVirtual</div>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-ivirtual"
                          formControlName="cus_can_ivirtual">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-ivirtual">
                          Puede utilizar IVirtual
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Examedi</div>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-examedi"
                          formControlName="cus_can_examedi">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-examedi">
                          Puede utilizar Examedi
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Yapp</div>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-can-yapp"
                          formControlName="cus_can_yapp">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-can-yapp">
                          Puede utilizar Yapp
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="customer-config-card">
                      <div class="customer-config-title">Validación Digital</div>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="edit-checkbox-autentika"
                          formControlName="cus_can_validate_autentika">
                        <label class="custom-control-label customer-checkbox-label" for="edit-checkbox-autentika">
                          Autentika
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- LOGO -->
              <div class="customer-section mb-2">
                <div class="customer-section-title mb-2">Logo del cliente</div>

                <div class="d-flex flex-wrap align-items-center">
                  <label class="buttonStyleSecondary customer-file-button mb-0 mr-3">
                    Examinar
                    <input
                      type="file"
                      accept="image/png,image/jpeg"
                      (change)="onFileSelectedEdit($event)">
                  </label>

                  <ng-container *ngIf="editCustomerForm.get('cus_image')?.value as selectedImage">
                    <span class="customer-file-chip">
                      {{ selectedImage.name }}
                    </span>
                  </ng-container>

                  <ng-container
                    *ngIf="!editCustomerForm.get('cus_image')?.value && editCustomerSelected.cus_url_image_web">
                    <a
                      class="customer-current-image-link"
                      [href]="editCustomerSelected.cus_url_image_web"
                      target="_blank">
                      Ver logo actual
                    </a>
                  </ng-container>
                </div>

                <div class="customer-file-help mt-2">
                  <b>Opcional.</b> Máximo 20 MB. Formatos JPG o PNG.
                </div>
              </div>

              <div class="modal-footer d-flex justify-content-between customer-tab-footer">
                <button
                  type="button"
                  class="buttonStyleSecondary customer-modal-button"
                  data-dismiss="modal"
                  (click)="onCloseEditCustomerModal()">
                  Cerrar
                </button>

                <button
                  type="button"
                  class="primary buttonStylePrimary customer-modal-button"
                  (click)="confirmEdit()">
                  Guardar cambios
                </button>
              </div>
            </form>
          </div>

          <!-- ========================================================= -->
          <!-- TAB COLORES -->
          <!-- ========================================================= -->
          <div
            class="tab-pane fade"
            id="tab-colores"
            role="tabpanel"
            aria-labelledby="tab-colores-tab">

            <form [formGroup]="editColorsForm">
              <div class="customer-section mb-3">
                <div class="customer-section-title mb-2">Colores (opcional)</div>

                <div class="custom-control custom-switch mt-2">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-enable-colors"
                    formControlName="enabled">
                  <label class="custom-control-label customer-label" for="switch-enable-colors">
                    Activar colores
                  </label>
                </div>

                <div
                  class="mt-3 row"
                  [style.opacity]="editColorsForm.get('enabled')?.value ? '1' : '.55'">

                  <div class="col-12 col-md-4 mb-3" *ngFor="let colorIndex of [1,2,3,4,5,6]">
                    <label class="customer-label">
                      Color {{ colorIndex }}
                    </label>

                    <div class="d-flex align-items-center">
                      <input
                        type="color"
                        class="form-control p-1 customer-color-picker"
                        [formControlName]="'cus_color_' + colorIndex">

                      <input
                        type="text"
                        class="form-control ml-2 customer-control"
                        placeholder="#171994 (opcional)"
                        [formControlName]="'cus_color_' + colorIndex">
                    </div>
                  </div>
                </div>

                <div class="customer-file-help mt-1">
                  Todos los colores son <b>opcionales</b>.
                </div>
              </div>

              <div class="modal-footer d-flex justify-content-between customer-tab-footer">
                <button
                  type="button"
                  class="buttonStyleSecondary customer-modal-button"
                  data-dismiss="modal">
                  Cerrar
                </button>

                <button
                  type="button"
                  class="primary buttonStylePrimary customer-modal-button"
                  (click)="confirmEditColors()">
                  Guardar cambios
                </button>
              </div>
            </form>
          </div>

          <!-- ========================================================= -->
          <!-- TAB COLORES PREDETERMINADOS -->
          <!-- ========================================================= -->
          <div
            class="tab-pane fade"
            id="tab-colores-default"
            role="tabpanel"
            aria-labelledby="tab-colores-default-tab">

            <form [formGroup]="editDefaultColorsForm">
              <div class="customer-section mb-3">
                <div class="customer-section-title mb-2">
                  Colores predeterminados (fallback)
                </div>

                <div class="customer-file-help">
                  Se usarán cuando el cliente <b>NO</b> tenga “Activar colores” habilitado.
                </div>

                <div class="mt-3 row">
                  <div class="col-12 col-md-4 mb-3" *ngFor="let colorIndex of [1,2,3,4,5,6]">
                    <label class="customer-label">
                      Color {{ colorIndex }}
                    </label>

                    <div class="d-flex align-items-center">
                      <input
                        type="color"
                        class="form-control p-1 customer-color-picker"
                        [formControlName]="'cus_color_' + colorIndex">

                      <input
                        type="text"
                        class="form-control ml-2 customer-control"
                        [formControlName]="'cus_color_' + colorIndex">
                    </div>
                  </div>
                </div>

                <div class="customer-file-help mt-1">
                  Recomendación: usa valores hex válidos tipo <b>#171994</b>.
                </div>
              </div>

              <div class="modal-footer d-flex justify-content-between customer-tab-footer">
                <button
                  type="button"
                  class="buttonStyleSecondary customer-modal-button"
                  data-dismiss="modal">
                  Cerrar
                </button>

                <button
                  type="button"
                  class="primary buttonStylePrimary customer-modal-button"
                  (click)="confirmEditDefaultColors()">
                  Guardar cambios
                </button>
              </div>
            </form>
          </div>

          <!-- ========================================================= -->
          <!-- TAB FONDOS POR PERFIL -->
          <!-- ========================================================= -->
          <div
            class="tab-pane fade"
            id="tab-fondos"
            role="tabpanel"
            aria-labelledby="tab-fondos-tab">

            <div class="customer-section mb-3">
              <div class="customer-section-title mb-2">
                Fondos por perfil (opcional)
              </div>

              <!-- PACIENTE -->
              <div class="customer-bg-card customer-bg-paciente mb-3">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <div class="customer-bg-title">Paciente</div>
                    <div class="customer-file-help">
                      Activa y sube una imagen de fondo para paciente.
                    </div>
                  </div>

                  <div class="d-flex align-items-center mt-2 mt-md-0">
                    <div class="custom-control custom-switch mr-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="switch-bg-paciente"
                        [checked]="editCustomerBackgrounds.paciente.enabled"
                        [disabled]="!canEnableCustom('paciente')"
                        (change)="onToggleBackgroundPerfil('paciente', $event)">
                      <label class="custom-control-label customer-label" for="switch-bg-paciente">
                        Activar
                      </label>
                    </div>

                    <label class="buttonStyleSecondary customer-file-button mb-0">
                      {{ (editCustomerBackgrounds.paciente.file || hasCustomBg('paciente')) ? 'Cambiar imagen' : 'Subir imagen' }}
                      <input
                        type="file"
                        accept="image/*"
                        (change)="onBgSelectedEdit($event, 'paciente')">
                    </label>
                  </div>
                </div>

                <div class="mt-2">
                  <span class="customer-file-chip" *ngIf="editCustomerBackgrounds.paciente.file">
                    {{ editCustomerBackgrounds.paciente.file.name }}
                  </span>
                  <span class="customer-no-file" *ngIf="!editCustomerBackgrounds.paciente.file">
                    Sin archivo seleccionado
                  </span>
                </div>

                <div class="customer-preview mt-3" *ngIf="getCustomPreviewUrl('paciente')">
                  <div class="customer-preview-header">
                    <div class="customer-label mb-0">Vista previa</div>
                    <button
                      *ngIf="canShowRemoveImage('paciente')"
                      type="button"
                      class="buttonStyleSecondary customer-small-button"
                      (click)="removeImage('paciente')">
                      Quitar imagen
                    </button>
                  </div>
                  <img [src]="getCustomPreviewUrl('paciente')" alt="preview paciente">
                </div>
              </div>

              <!-- DOCTOR -->
              <div class="customer-bg-card customer-bg-doctor mb-3">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <div class="customer-bg-title">Doctor</div>
                    <div class="customer-file-help">
                      Activa y sube una imagen de fondo para doctor.
                    </div>
                  </div>

                  <div class="d-flex align-items-center mt-2 mt-md-0">
                    <div class="custom-control custom-switch mr-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="switch-bg-doctor"
                        [checked]="editCustomerBackgrounds.doctor.enabled"
                        [disabled]="!canEnableCustom('doctor')"
                        (change)="onToggleBackgroundPerfil('doctor', $event)">
                      <label class="custom-control-label customer-label" for="switch-bg-doctor">
                        Activar
                      </label>
                    </div>

                    <!-- TABS CONTENT -->
                    <div class="tab-content" style="padding: 22px 22px 0;">

                         <!-- TAB 1: DATOS -->
                         <div class="tab-pane fade" id="tab-datos" role="tabpanel" aria-labelledby="tab-datos-tab">

                              <!-- DATOS PRINCIPALES -->
                              <div class="mb-3"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-3" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Datos del cliente
                                   </div>

                                   <div class="row">
                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Nombre
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.cus_name">
                                        </div>

                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  URL página
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.cus_url_site">
                                        </div>

                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Teléfono
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.cus_url_phone">
                                        </div>

                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Chat Ayuda 24/7
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.cus_url_wsp">
                                        </div>

                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Link Centro de Ayuda
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.link_centro_ayuda">
                                        </div>

                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Link ir al Sitio Web
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.link_volver_sitio">
                                        </div>
                                        <div class="col-12 col-md-3 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Mail de Contacto
                                             </label>
                                             <input type="text" class="form-control"
                                                  style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                  [(ngModel)]="editCustomerSelected.cus_mail_contact">
                                        </div>
                                   </div>
                              </div>

                              <!-- CONFIGURACIONES -->
                              <div class="mb-3"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-3" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Configuraciones
                                   </div>

                                   <div class="row" style="display: flex; flex-direction: column; gap: 5px;">


                                        <!-- MEDIOS DE PAGO -->
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Medios de pago
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-pay"
                                                            [(ngModel)]="editCustomerSelected.cus_can_pay"
                                                            name="check_can_pay">
                                                       <label class="custom-control-label" for="checkbox-can-pay"
                                                            style="font-family: Mulish; color:#171994;">
                                                            WebPay
                                                       </label>
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-snabb"
                                                            [(ngModel)]="editCustomerSelected.cus_can_snabb"
                                                            name="check_can_pay">
                                                       <label class="custom-control-label" for="checkbox-can-snabb"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Snabb
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>

                                        <!-- CONVENIOS PARTICULARES -->
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Convenios particulares
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-convenios"
                                                            [(ngModel)]="editCustomerSelected.cus_can_convenio_particular"
                                                            name="cus_can_convenio_particular">
                                                       <label class="custom-control-label" for="checkbox-can-convenios"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Tiene convenios particulares
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>

                                        <!-- SUSCRIPCION A PLANES -->
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">

                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Medios de pago Suscripción a planes
                                                  </div>

                                                  <!-- Descuento por planilla -->
                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-subscription-planilla"
                                                            [(ngModel)]="editCustomerSelected.cus_can_subscription_planilla"
                                                            name="check_can_subscription_planilla">

                                                       <label class="custom-control-label"
                                                            for="checkbox-can-subscription-planilla"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Descuento por planilla
                                                       </label>
                                                  </div>

                                                  <!-- Tarjeta -->
                                                  <div class="custom-control custom-checkbox mt-2">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-subscription-card"
                                                            [(ngModel)]="editCustomerSelected.cus_can_subscription_card"
                                                            (ngModelChange)="onChangeSubscriptionCard($event)"
                                                            name="check_can_subscription_card">

                                                       <label class="custom-control-label"
                                                            for="checkbox-can-subscription-card"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Tarjeta
                                                       </label>
                                                  </div>

                                                  <!-- Pasarelas de pago con tarjeta -->
                                                  <div *ngIf="editCustomerSelected.cus_can_subscription_card"
                                                       class="mt-2 pl-4">

                                                       <div class="custom-control custom-checkbox">
                                                            <input type="checkbox" class="custom-control-input"
                                                                 id="checkbox-can-subscription-mp"
                                                                 [(ngModel)]="editCustomerSelected.cus_can_subscription_mp"
                                                                 name="check_can_subscription_mp">

                                                            <label class="custom-control-label"
                                                                 for="checkbox-can-subscription-mp"
                                                                 style="font-family: Mulish; color:#171994;">
                                                                 Mercado Pago
                                                            </label>
                                                       </div>

                                                       <div class="custom-control custom-checkbox mt-1">
                                                            <input type="checkbox" class="custom-control-input"
                                                                 id="checkbox-can-subscription-wp"
                                                                 [(ngModel)]="editCustomerSelected.cus_can_subscription_wp"
                                                                 name="check_can_subscription_wp">

                                                            <label class="custom-control-label"
                                                                 for="checkbox-can-subscription-wp"
                                                                 style="font-family: Mulish; color:#171994;">
                                                                 WebPay - OneClick
                                                            </label>
                                                       </div>
                                                       <div class="custom-control custom-checkbox mt-1">
                                                            <input type="checkbox" class="custom-control-input"
                                                                 id="checkbox-can-subscription-vp"
                                                                 [(ngModel)]="editCustomerSelected.cus_can_subscription_vp"
                                                                 name="check_can_subscription_vp">

                                                            <label class="custom-control-label"
                                                                 for="checkbox-can-subscription-vp"
                                                                 style="font-family: Mulish; color:#171994;">
                                                                 VirtualPos
                                                            </label>
                                                       </div>

                                                  </div>

                                             </div>
                                        </div>


                                        <!-- BENEFICIOS -->
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Beneficios
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-show"
                                                            [(ngModel)]="editCustomerSelected.cus_can_show_agreement"
                                                            name="check_can-show">
                                                       <label class="custom-control-label" for="checkbox-can-show"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Se visualizan beneficios y prestaciones
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>

                                        <!-- IVIRTUAL -->
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       IVirtual
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-ivirtual"
                                                            [(ngModel)]="editCustomerSelected.cus_can_ivirtual"
                                                            name="check_can_ivirtual">
                                                       <label class="custom-control-label" for="checkbox-can-ivirtual"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Puede utilizar IVirtual
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>
                                        <!-- EXAMEDI -->
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Examedi
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-examedi"
                                                            [(ngModel)]="editCustomerSelected.cus_can_examedi"
                                                            name="check_can_examedi">
                                                       <label class="custom-control-label" for="checkbox-can-examedi"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Puede utilizar Examedi
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>
                                        <!-- YAPP -->
                                         <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Yapp
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-can-yapp"
                                                            [(ngModel)]="editCustomerSelected.cus_can_yapp"
                                                            name="check_can_yapp">
                                                       <label class="custom-control-label" for="checkbox-can-yapp"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Puede utilizar Yapp
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>
                                        <div class="col-12">
                                             <div class="p-3 h-100"
                                                  style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #FBFCFF;">
                                                  <div class="mb-2"
                                                       style="font-family: Mulish; font-weight: 900; color:#171994;">
                                                       Validación Digital
                                                  </div>

                                                  <div class="custom-control custom-checkbox">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="checkbox-autentika"
                                                            [(ngModel)]="editCustomerSelected.cus_can_validate_autentika"
                                                            name="check_can_yapp">
                                                       <label class="custom-control-label" for="checkbox-autentika"
                                                            style="font-family: Mulish; color:#171994;">
                                                            Autentika
                                                       </label>
                                                  </div>
                                             </div>
                                        </div>

                                   </div>
                              </div>

                              <!-- DOCUMENTO / IMAGEN -->
                              <div class="mb-2"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-2" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Logo del cliente
                                   </div>

                                   <div class="d-flex flex-wrap align-items-center">
                                        <label class="buttonStyleSecondary mb-0 mr-3"
                                             style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                             Examinar
                                             <input type="file" style="display:none; cursor:pointer !important;"
                                                  (change)="onFileSelectedEdit($event)" required />
                                        </label>

                                        <ng-container *ngIf="editCustomerSelected.cus_image">
                                             <span
                                                  style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                  {{editCustomerSelected.cus_image.name}}
                                             </span>
                                        </ng-container>
                                   </div>

                                   <div class="mt-2"
                                        style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        <b>Máximo 20 MB</b> (solo archivos .PNG)
                                   </div>
                              </div>

                              <!-- FOOTER TAB 1 -->
                              <div class="modal-footer d-flex justify-content-between"
                                   style="border-top: 1px solid rgba(23,25,148,.10); padding: 14px 18px; margin-top: 10px;">
                                   <button type="button" class="buttonStyleSecondary" data-dismiss="modal"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Cerrar
                                   </button>

                                   <button type="button" class="primary buttonStylePrimary" (click)="confirmEdit()"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Guardar cambios
                                   </button>
                              </div>
                         </div>

                         <!-- TAB 2: COLORES -->
                         <div class="tab-pane fade" id="tab-colores" role="tabpanel" aria-labelledby="tab-colores-tab">

                              <div class="mb-3"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-2" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Colores (opcional)
                                   </div>

                                   <div class="custom-control custom-switch mt-2 mt-md-0">
                                        <input type="checkbox" class="custom-control-input" id="switch-enable-colors"
                                             [(ngModel)]="editCustomerColors.enabled" name="switch_enable_colors">
                                        <label class="custom-control-label" for="switch-enable-colors"
                                             style="font-family: Mulish; font-weight: 800; color:#171994;">
                                             Activar colores
                                        </label>
                                   </div>

                                   <div class="mt-3 row" [style.opacity]="editCustomerColors.enabled ? '1' : '.55'">

                                        <!-- 1 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color primario
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerColors.cus_color_1" name="cus_color_1">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       placeholder="#171994 (opcional)"
                                                       [(ngModel)]="editCustomerColors.cus_color_1"
                                                       name="cus_color_1_text">
                                             </div>
                                        </div>

                                        <!-- 2 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color secundario
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerColors.cus_color_2" name="cus_color_2">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       placeholder="#F6F8FF (opcional)"
                                                       [(ngModel)]="editCustomerColors.cus_color_2"
                                                       name="cus_color_2_text">
                                             </div>
                                        </div>

                                        <!-- 3 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color Terciario
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerColors.cus_color_3" name="cus_color_3">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       placeholder="#316AD8 (opcional)"
                                                       [(ngModel)]="editCustomerColors.cus_color_3"
                                                       name="cus_color_3_text">
                                             </div>
                                        </div>

                                        <!-- 4 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color Cuarto
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerColors.cus_color_4" name="cus_color_4">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       placeholder="#FFFFFF (opcional)"
                                                       [(ngModel)]="editCustomerColors.cus_color_4"
                                                       name="cus_color_4_text">
                                             </div>
                                        </div>

                                        <!-- 5 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color Quinto
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerColors.cus_color_5" name="cus_color_5">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       placeholder="#171994 (opcional)"
                                                       [(ngModel)]="editCustomerColors.cus_color_5"
                                                       name="cus_color_5_text">
                                             </div>
                                        </div>

                                        <!-- 6 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color Sexto
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerColors.cus_color_6" name="cus_color_6">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       placeholder="rgba(...) o #... (opcional)"
                                                       [(ngModel)]="editCustomerColors.cus_color_6"
                                                       name="cus_color_6_text">
                                             </div>
                                        </div>

                                   </div>

                                   <div class="mt-1"
                                        style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        Todos los colores son <b>opcionales</b>. Si no seleccionas ninguno, no se
                                        modifican.
                                   </div>
                              </div>

                              <!-- FOOTER TAB 2 -->
                              <div class="modal-footer d-flex justify-content-between"
                                   style="border-top: 1px solid rgba(23,25,148,.10); padding: 14px 18px; margin-top: 10px;">
                                   <button type="button" class="buttonStyleSecondary" data-dismiss="modal"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Cerrar
                                   </button>

                                   <button type="button" class="primary buttonStylePrimary"
                                        (click)="confirmEditColors()"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Guardar cambios
                                   </button>
                              </div>
                         </div>
                         <!-- TAB 4: COLORES PREDETERMINADOS -->
                         <div class="tab-pane fade" id="tab-colores-default" role="tabpanel"
                              aria-labelledby="tab-colores-default-tab">

                              <div class="mb-3"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-2" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Colores predeterminados (fallback)
                                   </div>

                                   <div style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        Se usarán cuando el cliente <b>NO</b> tenga “Activar colores” habilitado.
                                   </div>

                                   <div class="mt-3 row">

                                        <!-- 1 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color primario
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_1"
                                                       name="def_cus_color_1">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_1"
                                                       name="def_cus_color_1_text">
                                             </div>
                                        </div>

                                        <!-- 2 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color secundario
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_2"
                                                       name="def_cus_color_2">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_2"
                                                       name="def_cus_color_2_text">
                                             </div>
                                        </div>

                                        <!-- 3 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color terciario
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_3"
                                                       name="def_cus_color_3">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_3"
                                                       name="def_cus_color_3_text">
                                             </div>
                                        </div>

                                        <!-- 4 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color cuarto
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_4"
                                                       name="def_cus_color_4">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_4"
                                                       name="def_cus_color_4_text">
                                             </div>
                                        </div>

                                        <!-- 5 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color quinto
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_5"
                                                       name="def_cus_color_5">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_5"
                                                       name="def_cus_color_5_text">
                                             </div>
                                        </div>

                                        <!-- 6 -->
                                        <div class="col-12 col-md-4 mb-3">
                                             <label class="mb-1"
                                                  style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                  Color sexto
                                             </label>
                                             <div class="d-flex align-items-center">
                                                  <input type="color" class="form-control p-1"
                                                       style="height: 40px; border-radius: 10px; border: 1px solid rgba(23,25,148,.15); max-width: 70px;"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_6"
                                                       name="def_cus_color_6">
                                                  <input type="text" class="form-control ml-2"
                                                       style="font-family: Mulish; border-radius: 10px; border: 1px solid rgba(23,25,148,.15);"
                                                       [(ngModel)]="editCustomerDefaultColors.cus_color_6"
                                                       name="def_cus_color_6_text">
                                             </div>
                                        </div>

                                   </div>

                                   <div class="mt-1"
                                        style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        Recomendación: usa valores hex válidos tipo <b>#171994</b>.
                                   </div>
                              </div>

                              <div class="modal-footer d-flex justify-content-between"
                                   style="border-top: 1px solid rgba(23,25,148,.10); padding: 14px 18px; margin-top: 10px;">
                                   <button type="button" class="buttonStyleSecondary" data-dismiss="modal"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Cerrar
                                   </button>

                                   <button type="button" class="primary buttonStylePrimary"
                                        (click)="confirmEditDefaultColors()"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Guardar cambios
                                   </button>
                              </div>

                         </div>

                         <!-- TAB 3: FONDOS POR PERFIL (INDEPENDIENTE) -->
                         <div class="tab-pane fade" id="tab-fondos" role="tabpanel" aria-labelledby="tab-fondos-tab">

                              <div class="mb-3"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-2" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Fondos por perfil (opcional)
                                   </div>

                                   <!-- PACIENTE -->
                                   <div class="mb-3 p-3"
                                        style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #b8d3fb;">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                                             <div>
                                                  <div
                                                       style="font-family: Mulish; font-weight: 900; color:#171994; font-size: 20px;">
                                                       Paciente</div>
                                                  <div
                                                       style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                                       Activa y sube una imagen de fondo para paciente.
                                                  </div>
                                             </div>
                                             <div class="d-flex align-items-center mt-2 mt-md-0">
                                                  <div class="custom-control custom-switch mr-3">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="switch-bg-paciente"
                                                            [(ngModel)]="editCustomerBackgrounds.paciente.enabled"
                                                            [disabled]="!canEnableCustom('paciente')"
                                                            (change)="onToggleBackgroundPerfil('paciente')">
                                                       <label class="custom-control-label" for="switch-bg-paciente"
                                                            style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                            Activar
                                                       </label>
                                                  </div>

                                                  <label class="buttonStyleSecondary mb-0"
                                                       style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                                       {{ (editCustomerBackgrounds.paciente.file ||
                                                       hasCustomBg('paciente')) ? 'Cambiar imagen' : 'Subir imagen'
                                                       }}
                                                       <input type="file" accept="image/*"
                                                            style="display:none; cursor:pointer !important;"
                                                            (change)="onBgSelectedEdit($event, 'paciente')">
                                                  </label>
                                             </div>
                                        </div>

                                        <div class="mt-2">
                                             <ng-container *ngIf="editCustomerBackgrounds.paciente.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                       {{editCustomerBackgrounds.paciente.file.name}}
                                                  </span>
                                             </ng-container>
                                             <ng-container *ngIf="!editCustomerBackgrounds.paciente.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.55); font-size: 13px;">
                                                       Sin archivo seleccionado
                                                  </span>
                                             </ng-container>
                                        </div>

                                        <!-- PREVIEW -->
                                        <div class="mt-3" *ngIf="getCustomPreviewUrl('paciente')"
                                             style="border-radius: 12px; overflow: hidden; border: 1px solid rgba(23,25,148,.10); background:#fff;">
                                             <div
                                                  style="padding:10px 12px; display:flex; align-items:center; justify-content:space-between; background:#F6F8FF;">
                                                  <div style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                       Vista previa
                                                  </div>

                                                  <button *ngIf="canShowRemoveImage('paciente')" type="button"
                                                       class="buttonStyleSecondary"
                                                       style="height: 34px; padding: 0 12px; border-radius: 10px;"
                                                       (click)="removeImage('paciente')">
                                                       Quitar imagen
                                                  </button>
                                             </div>

                                             <div style="max-height: 180px; overflow:hidden;">
                                                  <img [src]="getCustomPreviewUrl('paciente')" alt="preview paciente"
                                                       style="width: 100%; height: 180px; object-fit: cover; display:block;">
                                             </div>
                                        </div>
                                   </div>

                                   <!-- DOCTOR -->
                                   <div class="mb-3 p-3"
                                        style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #aaf9e8;">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                                             <div>
                                                  <div
                                                       style="font-family: Mulish; font-weight: 900; color:#171994; font-size: 20px;">
                                                       Doctor</div>
                                                  <div
                                                       style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                                       Activa y sube una imagen de fondo para doctor.
                                                  </div>
                                             </div>

                                             <div class="d-flex align-items-center mt-2 mt-md-0">
                                                  <div class="custom-control custom-switch mr-3">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="switch-bg-doctor"
                                                            [(ngModel)]="editCustomerBackgrounds.doctor.enabled"
                                                            [disabled]="!canEnableCustom('doctor')"
                                                            (change)="onToggleBackgroundPerfil('doctor')">
                                                       <label class="custom-control-label" for="switch-bg-doctor"
                                                            style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                            Activar
                                                       </label>
                                                  </div>

                                                  <label class="buttonStyleSecondary mb-0"
                                                       style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                                       {{ (editCustomerBackgrounds.doctor.file ||
                                                       hasCustomBg('doctor'))
                                                       ? 'Cambiar imagen' : 'Subir imagen' }} <input type="file"
                                                            accept="image/*"
                                                            style="display:none; cursor:pointer !important;"
                                                            (change)="onBgSelectedEdit($event, 'doctor')">
                                                  </label>
                                             </div>
                                        </div>

                                        <div class="mt-2">
                                             <ng-container *ngIf="editCustomerBackgrounds.doctor.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                       {{editCustomerBackgrounds.doctor.file.name}}
                                                  </span>
                                             </ng-container>
                                             <ng-container *ngIf="!editCustomerBackgrounds.doctor.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.55); font-size: 13px;">
                                                       Sin archivo seleccionado
                                                  </span>
                                             </ng-container>
                                        </div>

                                        <!-- PREVIEW -->
                                        <div class="mt-3" *ngIf="getCustomPreviewUrl('doctor')"
                                             style="border-radius: 12px; overflow: hidden; border: 1px solid rgba(23,25,148,.10); background:#fff;">
                                             <div
                                                  style="padding:10px 12px; display:flex; align-items:center; justify-content:space-between; background:#F6F8FF;">
                                                  <div style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                       Vista previa
                                                  </div>

                                                  <button *ngIf="canShowRemoveImage('doctor')" type="button"
                                                       class="buttonStyleSecondary"
                                                       style="height: 34px; padding: 0 12px; border-radius: 10px;"
                                                       (click)="removeImage('doctor')">
                                                       Quitar imagen
                                                  </button>
                                             </div>

                                             <div style="max-height: 180px; overflow:hidden;">
                                                  <img [src]="getCustomPreviewUrl('doctor')" alt="preview doctor"
                                                       style="width: 100%; height: 180px; object-fit: cover; display:block;">
                                             </div>
                                        </div>
                                   </div>

                                   <!-- TRABAJADORES -->
                                   <div class="mb-2 p-3"
                                        style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #f1ffa7;">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                                             <div>
                                                  <div
                                                       style="font-family: Mulish; font-weight: 900; color:#171994; font-size: 20px;">
                                                       Trabajadores</div>
                                                  <div
                                                       style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                                       Activa y sube una imagen de fondo para trabajadores.
                                                  </div>
                                             </div>

                                             <div class="d-flex align-items-center mt-2 mt-md-0">
                                                  <div class="custom-control custom-switch mr-3">
                                                       <input type="checkbox" class="custom-control-input"
                                                            id="switch-bg-trabajadores"
                                                            [(ngModel)]="editCustomerBackgrounds.trabajadores.enabled"
                                                            [disabled]="!canEnableCustom('trabajadores')"
                                                            (change)="onToggleBackgroundPerfil('trabajadores')">
                                                       <label class="custom-control-label" for="switch-bg-trabajadores"
                                                            style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                            Activar
                                                       </label>
                                                  </div>

                                                  <label class="buttonStyleSecondary mb-0"
                                                       style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                                       {{ (editCustomerBackgrounds.trabajadores.file ||
                                                       hasCustomBg('trabajadores')) ? 'Cambiar imagen' : 'Subir
                                                       imagen'
                                                       }} <input type="file" accept="image/*"
                                                            style="display:none; cursor:pointer !important;"
                                                            (change)="onBgSelectedEdit($event, 'trabajadores')">
                                                  </label>
                                             </div>
                                        </div>

                                        <div class="mt-2">
                                             <ng-container *ngIf="editCustomerBackgrounds.trabajadores.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                       {{editCustomerBackgrounds.trabajadores.file.name}}
                                                  </span>
                                             </ng-container>
                                             <ng-container *ngIf="!editCustomerBackgrounds.trabajadores.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.55); font-size: 13px;">
                                                       Sin archivo seleccionado
                                                  </span>
                                             </ng-container>
                                        </div>

                                        <div class="mt-3" *ngIf="getCustomPreviewUrl('trabajadores')"
                                             style="border-radius: 12px; overflow: hidden; border: 1px solid rgba(23,25,148,.10); background:#fff;">
                                             <div
                                                  style="padding:10px 12px; display:flex; align-items:center; justify-content:space-between; background:#F6F8FF;">
                                                  <div style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                       Vista previa
                                                  </div>

                                                  <button *ngIf="canShowRemoveImage('trabajadores')" type="button"
                                                       class="buttonStyleSecondary"
                                                       style="height: 34px; padding: 0 12px; border-radius: 10px;"
                                                       (click)="removeImage('trabajadores')">
                                                       Quitar imagen
                                                  </button>
                                             </div>

                                             <div style="max-height: 180px; overflow:hidden;">
                                                  <img [src]="getCustomPreviewUrl('trabajadores')"
                                                       alt="preview trabajadores"
                                                       style="width: 100%; height: 180px; object-fit: cover; display:block;">
                                             </div>
                                        </div>

                                   </div>

                                   <div class="mt-2"
                                        style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        Recomendación: JPG/PNG/WEBP. Idealmente imágenes livianas para no afectar
                                        la
                                        carga.
                                   </div>
                              </div>

                              <!-- FOOTER TAB 3 -->
                              <div class="modal-footer d-flex justify-content-between"
                                   style="border-top: 1px solid rgba(23,25,148,.10); padding: 14px 18px; margin-top: 10px;">
                                   <button type="button" class="buttonStyleSecondary" data-dismiss="modal"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Cerrar
                                   </button>

                                   <button type="button" class="primary buttonStylePrimary"
                                        (click)="confirmEditBackgrounds()"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Guardar cambios
                                   </button>
                              </div>
                         </div>

                         <!-- TAB: FONDOS PREDETERMINADOS -->
                         <div class="tab-pane fade" id="tab-fondos-default" role="tabpanel"
                              aria-labelledby="tab-fondos-default-tab">

                              <div class="mb-3"
                                   style="border: 1px solid rgba(23,25,148,.10); border-radius: 14px; padding: 16px; background: #fff;">
                                   <div class="mb-2" style="font-family: Mulish; font-weight: 900; color:#171994;">
                                        Fondos predeterminados (fallback)
                                   </div>

                                   <div style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        Estos fondos <b>siempre están habilitados</b> y se usan cuando el fondo del
                                        perfil está desactivado o no existe.
                                   </div>

                                   <!-- PACIENTE DEFAULT -->
                                   <div class="mt-3 mb-3 p-3"
                                        style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #b8d3fb;">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                                             <div>
                                                  <div
                                                       style="font-family: Mulish; font-weight: 900; color:#171994; font-size: 20px;">
                                                       Paciente</div>
                                                  <div
                                                       style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                                       Sube la imagen predeterminada para Paciente.
                                                  </div>
                                             </div>

                                             <label class="buttonStyleSecondary mb-0"
                                                  style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                                  {{ (editCustomerBackgroundsDefault.paciente.file ||
                                                  hasDefaultBg('paciente')) ? 'Cambiar imagen' : 'Subir imagen' }}
                                                  <input type="file" accept="image/*"
                                                       style="display:none; cursor:pointer !important;"
                                                       (change)="onBgSelectedEditDefault($event, 'paciente')">
                                             </label>
                                        </div>

                                        <div class="mt-2">
                                             <ng-container *ngIf="editCustomerBackgroundsDefault.paciente.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                       {{editCustomerBackgroundsDefault.paciente.file.name}}
                                                  </span>
                                             </ng-container>
                                             <ng-container *ngIf="!editCustomerBackgroundsDefault.paciente.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.55); font-size: 13px;">
                                                       Sin archivo seleccionado
                                                  </span>
                                             </ng-container>
                                        </div>

                                        <!-- PREVIEW -->
                                        <div class="mt-3" *ngIf="getBgPreviewUrlDefault('paciente')"
                                             style="border-radius: 12px; overflow: hidden; border: 1px solid rgba(23,25,148,.10); background:#fff;">
                                             <div
                                                  style="padding:10px 12px; display:flex; align-items:center; justify-content:space-between; background:#F6F8FF;">
                                                  <div style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                       Vista previa</div>

                                                  <button *ngIf="editCustomerBackgroundsDefault.paciente.file"
                                                       type="button" class="buttonStyleSecondary"
                                                       style="height: 34px; padding: 0 12px; border-radius: 10px;"
                                                       (click)="clearBgSelectionDefault('paciente')">
                                                       Quitar selección
                                                  </button>
                                             </div>

                                             <div style="max-height: 180px; overflow:hidden;">
                                                  <img [src]="getBgPreviewUrlDefault('paciente')"
                                                       alt="preview default paciente"
                                                       style="width: 100%; height: 180px; object-fit: cover; display:block;">
                                             </div>
                                        </div>
                                   </div>

                                   <!-- DOCTOR DEFAULT -->
                                   <div class="mb-3 p-3"
                                        style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #aaf9e8;">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                                             <div>
                                                  <div
                                                       style="font-family: Mulish; font-weight: 900; color:#171994; font-size: 20px;">
                                                       Doctor</div>
                                                  <div
                                                       style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                                       Sube la imagen predeterminada para Doctor.
                                                  </div>
                                             </div>

                                             <label class="buttonStyleSecondary mb-0"
                                                  style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                                  {{ (editCustomerBackgroundsDefault.doctor.file ||
                                                  hasDefaultBg('doctor')) ? 'Cambiar imagen' : 'Subir imagen' }}
                                                  <input type="file" accept="image/*"
                                                       style="display:none; cursor:pointer !important;"
                                                       (change)="onBgSelectedEditDefault($event, 'doctor')">
                                             </label>
                                        </div>

                                        <div class="mt-2">
                                             <ng-container *ngIf="editCustomerBackgroundsDefault.doctor.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                       {{editCustomerBackgroundsDefault.doctor.file.name}}
                                                  </span>
                                             </ng-container>
                                             <ng-container *ngIf="!editCustomerBackgroundsDefault.doctor.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.55); font-size: 13px;">
                                                       Sin archivo seleccionado
                                                  </span>
                                             </ng-container>
                                        </div>

                                        <!-- PREVIEW -->
                                        <div class="mt-3" *ngIf="getBgPreviewUrlDefault('doctor')"
                                             style="border-radius: 12px; overflow: hidden; border: 1px solid rgba(23,25,148,.10); background:#fff;">
                                             <div
                                                  style="padding:10px 12px; display:flex; align-items:center; justify-content:space-between; background:#F6F8FF;">
                                                  <div style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                       Vista previa</div>

                                                  <button *ngIf="editCustomerBackgroundsDefault.doctor.file"
                                                       type="button" class="buttonStyleSecondary"
                                                       style="height: 34px; padding: 0 12px; border-radius: 10px;"
                                                       (click)="clearBgSelectionDefault('doctor')">
                                                       Quitar selección
                                                  </button>
                                             </div>

                                             <div style="max-height: 180px; overflow:hidden;">
                                                  <img [src]="getBgPreviewUrlDefault('doctor')"
                                                       alt="preview default doctor"
                                                       style="width: 100%; height: 180px; object-fit: cover; display:block;">
                                             </div>
                                        </div>
                                   </div>

                                   <!-- TRABAJADORES DEFAULT -->
                                   <div class="mb-2 p-3"
                                        style="border: 1px solid rgba(23,25,148,.10); border-radius: 12px; background: #f1ffa7;">
                                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                                             <div>
                                                  <div
                                                       style="font-family: Mulish; font-weight: 900; color:#171994; font-size: 20px;">
                                                       Trabajadores</div>
                                                  <div
                                                       style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                                       Sube la imagen predeterminada para Trabajadores.
                                                  </div>
                                             </div>

                                             <label class="buttonStyleSecondary mb-0"
                                                  style="height: 40px; display:flex; align-items:center; padding: 0 14px; border-radius: 10px; cursor:pointer;">
                                                  {{ (editCustomerBackgroundsDefault.trabajadores.file ||
                                                  hasDefaultBg('trabajadores')) ? 'Cambiar imagen' : 'Subir imagen'
                                                  }}
                                                  <input type="file" accept="image/*"
                                                       style="display:none; cursor:pointer !important;"
                                                       (change)="onBgSelectedEditDefault($event, 'trabajadores')">
                                             </label>
                                        </div>

                                        <div class="mt-2">
                                             <ng-container *ngIf="editCustomerBackgroundsDefault.trabajadores.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.85); background: rgba(49,106,216,.08); padding: 6px 10px; border-radius: 999px;">
                                                       {{editCustomerBackgroundsDefault.trabajadores.file.name}}
                                                  </span>
                                             </ng-container>
                                             <ng-container *ngIf="!editCustomerBackgroundsDefault.trabajadores.file">
                                                  <span
                                                       style="font-family: Mulish; color: rgba(23,25,148,.55); font-size: 13px;">
                                                       Sin archivo seleccionado
                                                  </span>
                                             </ng-container>
                                        </div>

                                        <!-- PREVIEW -->
                                        <div class="mt-3" *ngIf="getBgPreviewUrlDefault('trabajadores')"
                                             style="border-radius: 12px; overflow: hidden; border: 1px solid rgba(23,25,148,.10); background:#fff;">
                                             <div
                                                  style="padding:10px 12px; display:flex; align-items:center; justify-content:space-between; background:#F6F8FF;">
                                                  <div style="font-family: Mulish; font-weight: 800; color:#171994;">
                                                       Vista previa</div>

                                                  <button *ngIf="editCustomerBackgroundsDefault.trabajadores.file"
                                                       type="button" class="buttonStyleSecondary"
                                                       style="height: 34px; padding: 0 12px; border-radius: 10px;"
                                                       (click)="clearBgSelectionDefault('trabajadores')">
                                                       Quitar selección
                                                  </button>
                                             </div>

                                             <div style="max-height: 180px; overflow:hidden;">
                                                  <img [src]="getBgPreviewUrlDefault('trabajadores')"
                                                       alt="preview default trabajadores"
                                                       style="width: 100%; height: 180px; object-fit: cover; display:block;">
                                             </div>
                                        </div>
                                   </div>

                                   <div class="mt-2"
                                        style="font-family: Mulish; font-size: 13px; color: rgba(23,25,148,.75);">
                                        Recomendación: JPG/PNG/WEBP. Idealmente imágenes livianas.
                                   </div>
                              </div>

                              <!-- FOOTER TAB DEFAULT -->
                              <div class="modal-footer d-flex justify-content-between"
                                   style="border-top: 1px solid rgba(23,25,148,.10); padding: 14px 18px; margin-top: 10px;">
                                   <button type="button" class="buttonStyleSecondary" data-dismiss="modal"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Cerrar
                                   </button>

                                   <button type="button" class="primary buttonStylePrimary"
                                        (click)="confirmEditBackgroundsDefault()"
                                        style="border-radius: 10px; height: 40px; padding: 0 18px;">
                                        Guardar cambios
                                   </button>
                              </div>

                         </div>

                    </div>
                  </div>

                  <div class="d-flex align-items-center mt-2 mt-md-0">
                    <div class="custom-control custom-switch mr-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="switch-bg-trabajadores"
                        [checked]="editCustomerBackgrounds.trabajadores.enabled"
                        [disabled]="!canEnableCustom('trabajadores')"
                        (change)="onToggleBackgroundPerfil('trabajadores', $event)">
                      <label class="custom-control-label customer-label" for="switch-bg-trabajadores">
                        Activar
                      </label>
                    </div>

                    <label class="buttonStyleSecondary customer-file-button mb-0">
                      {{ (editCustomerBackgrounds.trabajadores.file || hasCustomBg('trabajadores')) ? 'Cambiar imagen' : 'Subir imagen' }}
                      <input
                        type="file"
                        accept="image/*"
                        (change)="onBgSelectedEdit($event, 'trabajadores')">
                    </label>
                  </div>
                </div>

                <div class="mt-2">
                  <span class="customer-file-chip" *ngIf="editCustomerBackgrounds.trabajadores.file">
                    {{ editCustomerBackgrounds.trabajadores.file.name }}
                  </span>
                  <span class="customer-no-file" *ngIf="!editCustomerBackgrounds.trabajadores.file">
                    Sin archivo seleccionado
                  </span>
                </div>

                <div class="customer-preview mt-3" *ngIf="getCustomPreviewUrl('trabajadores')">
                  <div class="customer-preview-header">
                    <div class="customer-label mb-0">Vista previa</div>
                    <button
                      *ngIf="canShowRemoveImage('trabajadores')"
                      type="button"
                      class="buttonStyleSecondary customer-small-button"
                      (click)="removeImage('trabajadores')">
                      Quitar imagen
                    </button>
                  </div>
                  <img [src]="getCustomPreviewUrl('trabajadores')" alt="preview trabajadores">
                </div>
              </div>

              <div class="customer-file-help mt-2">
                Recomendación: JPG/PNG/WEBP. Idealmente imágenes livianas para no afectar la carga.
              </div>
            </div>

            <div class="modal-footer d-flex justify-content-between customer-tab-footer">
              <button
                type="button"
                class="buttonStyleSecondary customer-modal-button"
                data-dismiss="modal">
                Cerrar
              </button>

              <button
                type="button"
                class="primary buttonStylePrimary customer-modal-button"
                (click)="confirmEditBackgrounds()">
                Guardar cambios
              </button>
            </div>
          </div>

          <!-- ========================================================= -->
          <!-- TAB FONDOS PREDETERMINADOS -->
          <!-- ========================================================= -->
          <div
            class="tab-pane fade"
            id="tab-fondos-default"
            role="tabpanel"
            aria-labelledby="tab-fondos-default-tab">

            <div class="customer-section mb-3">
              <div class="customer-section-title mb-2">
                Fondos predeterminados (fallback)
              </div>

              <div class="customer-file-help">
                Estos fondos <b>siempre están habilitados</b> y se usan cuando el fondo del perfil está desactivado o no existe.
              </div>

              <!-- DEFAULT PACIENTE -->
              <div class="customer-bg-card customer-bg-paciente mt-3 mb-3">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <div class="customer-bg-title">Paciente</div>
                    <div class="customer-file-help">Sube la imagen predeterminada para Paciente.</div>
                  </div>

                  <label class="buttonStyleSecondary customer-file-button mb-0">
                    {{ (editCustomerBackgroundsDefault.paciente.file || hasDefaultBg('paciente')) ? 'Cambiar imagen' : 'Subir imagen' }}
                    <input
                      type="file"
                      accept="image/*"
                      (change)="onBgSelectedEditDefault($event, 'paciente')">
                  </label>
                </div>

                <div class="mt-2">
                  <span class="customer-file-chip" *ngIf="editCustomerBackgroundsDefault.paciente.file">
                    {{ editCustomerBackgroundsDefault.paciente.file.name }}
                  </span>
                  <span class="customer-no-file" *ngIf="!editCustomerBackgroundsDefault.paciente.file">
                    Sin archivo seleccionado
                  </span>
                </div>

                <div class="customer-preview mt-3" *ngIf="getBgPreviewUrlDefault('paciente')">
                  <div class="customer-preview-header">
                    <div class="customer-label mb-0">Vista previa</div>
                    <button
                      *ngIf="editCustomerBackgroundsDefault.paciente.file"
                      type="button"
                      class="buttonStyleSecondary customer-small-button"
                      (click)="clearBgSelectionDefault('paciente')">
                      Quitar selección
                    </button>
                  </div>
                  <img [src]="getBgPreviewUrlDefault('paciente')" alt="preview default paciente">
                </div>
              </div>

              <!-- DEFAULT DOCTOR -->
              <div class="customer-bg-card customer-bg-doctor mb-3">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <div class="customer-bg-title">Doctor</div>
                    <div class="customer-file-help">Sube la imagen predeterminada para Doctor.</div>
                  </div>

                  <label class="buttonStyleSecondary customer-file-button mb-0">
                    {{ (editCustomerBackgroundsDefault.doctor.file || hasDefaultBg('doctor')) ? 'Cambiar imagen' : 'Subir imagen' }}
                    <input
                      type="file"
                      accept="image/*"
                      (change)="onBgSelectedEditDefault($event, 'doctor')">
                  </label>
                </div>

                <div class="mt-2">
                  <span class="customer-file-chip" *ngIf="editCustomerBackgroundsDefault.doctor.file">
                    {{ editCustomerBackgroundsDefault.doctor.file.name }}
                  </span>
                  <span class="customer-no-file" *ngIf="!editCustomerBackgroundsDefault.doctor.file">
                    Sin archivo seleccionado
                  </span>
                </div>

                <div class="customer-preview mt-3" *ngIf="getBgPreviewUrlDefault('doctor')">
                  <div class="customer-preview-header">
                    <div class="customer-label mb-0">Vista previa</div>
                    <button
                      *ngIf="editCustomerBackgroundsDefault.doctor.file"
                      type="button"
                      class="buttonStyleSecondary customer-small-button"
                      (click)="clearBgSelectionDefault('doctor')">
                      Quitar selección
                    </button>
                  </div>
                  <img [src]="getBgPreviewUrlDefault('doctor')" alt="preview default doctor">
                </div>
              </div>

              <!-- DEFAULT TRABAJADORES -->
              <div class="customer-bg-card customer-bg-trabajadores mb-2">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <div class="customer-bg-title">Trabajadores</div>
                    <div class="customer-file-help">Sube la imagen predeterminada para Trabajadores.</div>
                  </div>

                  <label class="buttonStyleSecondary customer-file-button mb-0">
                    {{ (editCustomerBackgroundsDefault.trabajadores.file || hasDefaultBg('trabajadores')) ? 'Cambiar imagen' : 'Subir imagen' }}
                    <input
                      type="file"
                      accept="image/*"
                      (change)="onBgSelectedEditDefault($event, 'trabajadores')">
                  </label>
                </div>

                <div class="mt-2">
                  <span class="customer-file-chip" *ngIf="editCustomerBackgroundsDefault.trabajadores.file">
                    {{ editCustomerBackgroundsDefault.trabajadores.file.name }}
                  </span>
                  <span class="customer-no-file" *ngIf="!editCustomerBackgroundsDefault.trabajadores.file">
                    Sin archivo seleccionado
                  </span>
                </div>

                <div class="customer-preview mt-3" *ngIf="getBgPreviewUrlDefault('trabajadores')">
                  <div class="customer-preview-header">
                    <div class="customer-label mb-0">Vista previa</div>
                    <button
                      *ngIf="editCustomerBackgroundsDefault.trabajadores.file"
                      type="button"
                      class="buttonStyleSecondary customer-small-button"
                      (click)="clearBgSelectionDefault('trabajadores')">
                      Quitar selección
                    </button>
                  </div>
                  <img [src]="getBgPreviewUrlDefault('trabajadores')" alt="preview default trabajadores">
                </div>
              </div>

              <div class="customer-file-help mt-2">
                Recomendación: JPG/PNG/WEBP. Idealmente imágenes livianas.
              </div>
            </div>

            <div class="modal-footer d-flex justify-content-between customer-tab-footer">
              <button
                type="button"
                class="buttonStyleSecondary customer-modal-button"
                data-dismiss="modal">
                Cerrar
              </button>

              <button
                type="button"
                class="primary buttonStylePrimary customer-modal-button"
                (click)="confirmEditBackgroundsDefault()">
                Guardar cambios
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL EDITAR CLIENTE -->


<!-- ========================================================= -->
<!-- MODAL ELIMINAR CLIENTE -->
<!-- ========================================================= -->
<div
  class="modal fade hide"
  id="deleteCustomer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteCustomer"
  aria-hidden="true">

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h2 class="pModalTitle">Borrar cliente</h2>
      </div>

      <div class="modal-body">
        <div class="row modalBody" style="width: 100%;">
          <p class="pTableTitle">
            ¿Está seguro de eliminar al cliente {{ deleteSelected.cus_name }}?
          </p>
          <p style="display: flex; align-items: center;">
            <mat-icon>error_outline</mat-icon>
            Todos los planes asociados a este cliente se deshabilitarán.
          </p>
        </div>

        <div class="row modalBody" style="width: 100%;">
          <div class="col-md-6 modalBody">
            <button
              class="primary buttonStyleSecondary"
              data-toggle="modal"
              data-target="#deleteCustomer">
              Cancelar
            </button>
          </div>

          <div class="col-md-6 modalBody">
            <button class="primary buttonStylePrimary" (click)="confirmDelete()">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL ELIMINAR CLIENTE -->


<!-- ========================================================= -->
<!-- MODAL AGREGAR CLIENTE -->
<!-- MISMO FORMATO Y CAMPOS QUE EDICIÓN -->
<!-- ========================================================= -->
<div
  class="modal fade"
  id="addCustomer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addCustomer"
  aria-hidden="true">

  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content customer-modal-content">

      <div class="modal-header customer-modal-header justify-content-between align-items-center">
        <div>
          <h4 class="m-0 customer-modal-title">Agregar cliente</h4>
          <small class="customer-modal-subtitle">
            Ingresa los datos y configuraciones del nuevo cliente.
          </small>
        </div>

        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeCrearCustomer()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body customer-create-body">
        <form [formGroup]="addCustomerForm" novalidate>

          <!-- DATOS PRINCIPALES -->
          <div class="customer-section mb-3">
            <div class="customer-section-title mb-3">
              Datos del cliente
            </div>

            <div class="row">
              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  Nombre <span class="customer-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="cus_name"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'cus_name', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'cus_name', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'cus_name') }}
                </div>
              </div>

              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  URL página <span class="customer-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="cus_url"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'cus_url', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'cus_url', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'cus_url') }}
                </div>
              </div>

              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  Teléfono <span class="customer-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="cus_phone"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'cus_phone', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'cus_phone', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'cus_phone') }}
                </div>
              </div>

              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  Chat Ayuda 24/7 <span class="customer-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="cus_url_wsp"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'cus_url_wsp', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'cus_url_wsp', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'cus_url_wsp') }}
                </div>
              </div>

              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  Link Centro de Ayuda <span class="customer-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="link_centro_ayuda"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'link_centro_ayuda', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'link_centro_ayuda', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'link_centro_ayuda') }}
                </div>
              </div>

              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  Link ir al Sitio Web <span class="customer-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="link_volver_sitio"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'link_volver_sitio', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'link_volver_sitio', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'link_volver_sitio') }}
                </div>
              </div>

              <div class="col-12 col-md-3 mb-3">
                <label class="customer-label">
                  Mail de Contacto <span class="customer-required">*</span>
                </label>
                <input
                  type="email"
                  class="form-control customer-control"
                  formControlName="cus_mail_contact"
                  [class.is-invalid]="isFieldInvalid(addCustomerForm, 'cus_mail_contact', addCustomerSubmitted)">
                <div
                  class="customer-error"
                  *ngIf="isFieldInvalid(addCustomerForm, 'cus_mail_contact', addCustomerSubmitted)">
                  {{ getFieldError(addCustomerForm, 'cus_mail_contact') }}
                </div>
              </div>
            </div>
          </div>

          <!-- CONFIGURACIONES -->
          <div class="customer-section mb-3">
            <div class="customer-section-title mb-3">
              Configuraciones
            </div>

            <div class="row customer-config-list">

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Medios de pago</div>

                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-pay"
                      formControlName="cus_can_pay">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-pay">
                      WebPay
                    </label>
                  </div>

                  <div class="custom-control custom-checkbox mt-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-snabb"
                      formControlName="cus_can_snabb">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-snabb">
                      Snabb
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Convenios particulares</div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-convenios"
                      formControlName="cus_can_convenio_particular">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-convenios">
                      Tiene convenios particulares
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Medios de pago Suscripción a planes</div>

                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-subscription-planilla"
                      formControlName="cus_can_subscription_planilla">
                    <label
                      class="custom-control-label customer-checkbox-label"
                      for="add-checkbox-can-subscription-planilla">
                      Descuento por planilla
                    </label>
                  </div>

                  <div class="custom-control custom-checkbox mt-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-subscription-card"
                      formControlName="cus_can_subscription_card">
                    <label
                      class="custom-control-label customer-checkbox-label"
                      for="add-checkbox-can-subscription-card">
                      Tarjeta
                    </label>
                  </div>

                  <div
                    *ngIf="addCustomerForm.get('cus_can_subscription_card')?.value"
                    class="mt-2 pl-4">

                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="add-checkbox-can-subscription-mp"
                        formControlName="cus_can_subscription_mp">
                      <label
                        class="custom-control-label customer-checkbox-label"
                        for="add-checkbox-can-subscription-mp">
                        Mercado Pago
                      </label>
                    </div>

                    <div class="custom-control custom-checkbox mt-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="add-checkbox-can-subscription-wp"
                        formControlName="cus_can_subscription_wp">
                      <label
                        class="custom-control-label customer-checkbox-label"
                        for="add-checkbox-can-subscription-wp">
                        WebPay - OneClick
                      </label>
                    </div>
                    <div class="custom-control custom-checkbox mt-1">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="add-checkbox-can-subscription-vp"
                        formControlName="cus_can_subscription_vp">
                      <label
                        class="custom-control-label customer-checkbox-label"
                        for="add-checkbox-can-subscription-vp">
                        Virtual POS
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Beneficios</div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-show"
                      formControlName="cus_can_show_agreement">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-show">
                      Se visualizan beneficios y prestaciones
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">IVirtual</div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-ivirtual"
                      formControlName="cus_can_ivirtual">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-ivirtual">
                      Puede utilizar IVirtual
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Examedi</div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-examedi"
                      formControlName="cus_can_examedi">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-examedi">
                      Puede utilizar Examedi
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Yapp</div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-can-yapp"
                      formControlName="cus_can_yapp">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-can-yapp">
                      Puede utilizar Yapp
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="customer-config-card">
                  <div class="customer-config-title">Validación Digital</div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="add-checkbox-autentika"
                      formControlName="cus_can_validate_autentika">
                    <label class="custom-control-label customer-checkbox-label" for="add-checkbox-autentika">
                      Autentika
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- LOGO -->
          <div class="customer-section mb-2">
            <div class="customer-section-title mb-2">
              Logo del cliente
            </div>

            <div class="d-flex flex-wrap align-items-center">
              <label class="buttonStyleSecondary customer-file-button mb-0 mr-3">
                Examinar
                <input
                  type="file"
                  accept="image/png,image/jpeg"
                  (change)="onFileSelected($event)">
              </label>

              <ng-container *ngIf="addCustomerForm.get('cus_image')?.value as selectedImage">
                <span class="customer-file-chip">
                  {{ selectedImage.name }}
                </span>
              </ng-container>
            </div>

            <div class="customer-file-help mt-2">
              <b>Opcional.</b> Máximo 20 MB. Formatos JPG o PNG.
            </div>
          </div>

          <div class="modal-footer d-flex justify-content-between customer-tab-footer">
            <button
              type="button"
              class="buttonStyleSecondary customer-modal-button"
              data-dismiss="modal"
              (click)="closeCrearCustomer()">
              Cerrar
            </button>

            <button
              type="button"
              class="primary buttonStylePrimary customer-modal-button"
              (click)="confirmAdd()">
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL AGREGAR CLIENTE -->


<!-- ========================================================= -->
<!-- MODAL PRODUCTOS -->
<!-- ========================================================= -->
<div
  class="modal fade hide"
  id="showProducts"
  tabindex="-1"
  role="dialog"
  aria-labelledby="showProducts"
  aria-hidden="true">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h2 class="pModalTitle">
          Productos
          <mat-icon (click)="showProduct()">add</mat-icon>
        </h2>
      </div>

      <div class="modal-body">
        <div class="row modalBody" style="width: 100%;">
          <div class="col-4"><p>Producto</p></div>
          <div class="col-4"><p>Plan</p></div>
          <div class="col-4"><p>Acción</p></div>
          <div class="col-12"><hr></div>

          <ng-container
            *ngIf="!customerSelected || !customerSelected.products_list || customerSelected.products_list.length == 0; else products">
            <div class="not-plans">
              <div style="display: flex; flex-direction: row; align-items: center;">
                <mat-icon>info</mat-icon>
                <span>Este cliente no tiene productos disponibles.</span>
              </div>
            </div>
          </ng-container>

          <ng-template #products>
            <ng-container *ngFor="let product of customerSelected.products_list">
              <div class="col-4">
                <p>{{ product.cus_ben_pro_value }}</p>
              </div>
              <div class="col-4">
                <p>{{ product.cus_ben_name }}</p>
              </div>
              <div class="col-4">
                <button
                  type="button"
                  class="btn btn-secondary actionButton"
                  (click)="deleteProduct(product)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </ng-container>
          </ng-template>
        </div>

        <div class="row" style="justify-content: space-around;">
          <div class="col-xs-12" style="text-align: -webkit-center;">
            <button type="button" class="buttonStyleSecondary" data-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL PRODUCTOS -->


<!-- ========================================================= -->
<!-- MODAL AGREGAR PRODUCTO -->
<!-- ========================================================= -->
<div
  class="modal fade hide"
  id="insProducts"
  tabindex="-1"
  role="dialog"
  aria-labelledby="insProducts"
  aria-hidden="true">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h2 class="pModalTitle">Agregar producto</h2>
      </div>

      <div class="modal-body">
        <form [formGroup]="productForm">
          <div class="row modalBody" style="width: 100%;">

            <ng-container
              *ngIf="customerSelected && customerSelected.planes && customerSelected.planes.length > 0">

              <div class="col-6">
                <p>Producto</p>
                <input
                  type="text"
                  class="form-control customer-control"
                  formControlName="pro_value">
              </div>

              <div class="col-6">
                <p>Plan</p>
                <select class="form-control customer-control" formControlName="cus_ben_id">
                  <option value="">Plan asociado</option>
                  <ng-container *ngFor="let plan of customerSelected.planes">
                    <option [value]="plan.cus_ben_id">
                      {{ plan.cus_ben_name }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </ng-container>

            <ng-container
              *ngIf="!customerSelected || !customerSelected.planes || customerSelected.planes.length == 0">
              <div class="not-plans">
                <div style="display: flex; flex-direction: row;">
                  <mat-icon>info</mat-icon>
                  <span>No se puede agregar productos.</span>
                </div>
              </div>
            </ng-container>

            <div class="col-12"><hr></div>
          </div>

          <div class="row" style="justify-content: space-around;">
            <div class="col-xs-12" style="text-align: -webkit-center;">
              <button type="button" class="buttonStyleSecondary" data-dismiss="modal">
                Cerrar
              </button>
            </div>

            <div class="col-xs-12" style="text-align: -webkit-center;">
              <button
                type="button"
                class="primary buttonStylePrimary"
                (click)="addProduct()">
                Guardar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- TRIGGERS BOOTSTRAP -->
<button
  #editCustomerTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#editCustomer">
</button>

<button
  #deleteCustomerTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#deleteCustomer">
</button>

<button
  #addCustomerTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#addCustomer">
</button>

<button
  #showProductsTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#showProducts">
</button>

<button
  #insProductsTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#insProducts">
</button>
